import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ children, path, exact }) => {
  let auth = { isLogged: false };
  try {
    const raw = localStorage.getItem("persist:root");
    if (raw) {
      const rootData = JSON.parse(raw);
      if (rootData && rootData.auth) {
        auth = JSON.parse(rootData.auth);
      }
    }
  } catch (e) {
    // si falla parseo, tratamos como no logueado
  }

  return (
    <>
      {auth.isLogged ? (
        <Route path={path} exact={exact}>
          {children}
        </Route>
      ) : (
        <Redirect to="/" />
      )}
    </>
  );
};

export default PrivateRoute;
